import React, {useState} from 'react';
import './navigation.scss';
//library imports
import {Link, useNavigate, useLocation} from "react-router-dom";
import {HashLink} from 'react-router-hash-link';
import {useMediaQuery} from "react-responsive";

//local components
import {Button} from 'components';

//assets imports
import Logo from '../../assets/sbaj_logo.svg';
import {ReactComponent as HAMBURGER_ICON} from 'assets/icons/Hamburger_Icon.svg'
import {ReactComponent as MENU_CLOSE} from 'assets/icons/menu_close.svg'
import PHONE_ICON from 'assets/icons/phone_icon.svg';
import EMAIL_ICON from 'assets/icons/email_icon.svg';
import LOCATION_ICON from 'assets/icons/location_icon.svg';


export const Navigation: React.FC = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const [navigation] = useState<{ name: string, path: string, hasChildren: boolean, component?: any }[]>([
        // {
        //     name: "Home",
        //     path: "/home",
        //     hasChildren: false,
        //     component: {}
        // },
        {
            name: "Business Education",
            path: "/business-education",
            hasChildren: true,
            component: <BusinessEducationChildren/>
        },
        {
            name: "Accounting & Finance",
            path: "/finance",
            hasChildren: true,
            component: <AccountingFinanceChildren/>
        },
        {
            name: "News",
            path: "/news",
            hasChildren: false,
        },
        {
            name: "Events",
            path: "/events",
            hasChildren: false,
        },
        {
            name: "About Us",
            path: "/about",
            hasChildren: true,
            component: <AboutUsChildren/>
        },
    ]);
    const isTablet = useMediaQuery({query: '(max-width: 1000px)'});
    const isHome = pathname === "/";

    const OpenCloseMenu = () => {
        setIsOpen((prev) => !prev);
    }

    return (
        <div className={['nav', isHome && "home_nav", isOpen && 'mobile-nav-open'].join(' ')}>
            {isOpen && isTablet &&
            <div className="nav_mobile">
                <div className="nav_mobile_main">
                    <h1>Main Links</h1>
                    {navigation.map(({name, path}, index) => (
                        <div key={index}
                             className={['nav_mobile_main_link', pathname.includes(path) ? "active_mobile_link" : null].join(' ')}>
                            <Link to={path}>{name}</Link>
                        </div>
                    ))}
                </div>

                <div className="nav_mobile_contact">
                    <h1>Contact Us</h1>
                    <div className={'nav-contact-us'}>
                        <div className="nav-contact-us_child">
                            <div>
                                <img id="contact-phone" src={PHONE_ICON} alt=""/>
                            </div>
                            <span>(876) 927-7071</span>
                        </div>
                        <div className="nav-contact-us_child">
                            <div>
                                <img src={EMAIL_ICON} alt=""/>
                            </div>
                            <span>sbajinfo@sba-jm.org</span>
                        </div>
                        <div className="nav-contact-us_child">
                            <div>
                                <img src={LOCATION_ICON} alt=""/>
                            </div>
                            <span>2 Trafalgar Road, Kingston 5, Jamaica</span>
                        </div>
                    </div>
                </div>

                <div className={'nav_mobile_buttons'}>
                    <Button text={'Sign In'} type={'primary'} onclick={() => navigate('/login')}/>
                    <Button text={'Join Us'} type={'secondary'} onclick={() => navigate('/registration')}/>
                </div>

            </div>
            }

            <div className="nav_container max">
                <div className="nav_container_left">
                    <img src={Logo} alt="Logo" onClick={() => {
                        navigate('/')
                    }}/>
                </div>
                {isTablet && <div className="nav_container_right">
                    {isOpen ? <MENU_CLOSE onClick={OpenCloseMenu}/> :
                        <HAMBURGER_ICON className={'hamburger_menu'} onClick={OpenCloseMenu}/>}
                </div>}
                {!isTablet && <div className="nav_container_right">
                    <div className="links">
                        {navigation.map(({name, path, hasChildren, component}, index) => (
                            <div key={index}
                                 className={['links_link', pathname.includes(path) ? "active-link" : null].join(' ')}>
                                <Link to={path}>{name}</Link>
                                {hasChildren && component}
                            </div>
                        ))}
                    </div>
                    <div className="registration">
                        <div><Link to="/login">Sign In</Link></div>
                        <div><Link className={'registration_btn'} to="/registration">Join Us</Link></div>
                    </div>
                </div>
                }
            </div>
        </div>
    );
};


const BusinessEducationChildren = () => {
    return (
        <div className="links_link_children">
            <div className="links_link_children_left">
                <h1>Business Education</h1>
                <p>
                    This section could possibly be a slide, with information about various
                    features.
                </p>
            </div>
            <div className="links_link_children_right">
                <div className={'links_link_children_routes'}>
                    <HashLink smooth to="/business-education#packages_plan">Planning a Business</HashLink>
                    <HashLink smooth to="/business-education#packages_start">Starting a Business</HashLink>
                    <HashLink smooth to="/business-education#packages_grow">Growing a Business</HashLink>
                </div>
                <div className={'links_link_children_routes'}>
                    <HashLink smooth to="/business-education#Business_Benefits">Benefits</HashLink>
                    <HashLink smooth to="/business-education#business_industries">Business Industries</HashLink>
                    <HashLink smooth to="/business-education#business_testimonials">Testimonials</HashLink>
                </div>
            </div>
        </div>
    );
};

const AboutUsChildren = () => {
    return (
        <div className="links_link_children">
            <div className="links_link_children_left">
                <h1>About SBAJ</h1>
                <p>
                    This section could possibly be a slide, with information about various
                    features.
                </p>
            </div>
            <div className="links_link_children_right">
                <div className={'links_link_children_routes'}>
                    <HashLink smooth to="/about#mission">Our Mission</HashLink>
                    <HashLink smooth to="/about#values">Our Values</HashLink>
                    <HashLink smooth to="/about#history">Our History</HashLink>
                    <HashLink smooth to="/about#how-help">How Do We Help</HashLink>
                </div>
                <div className={'links_link_children_routes'}>
                </div>
                <div className={'links_link_children_routes'}>
                    <p>Contact Us</p>
                    <div className={'links_link_children_routes nav-contact-us'}>
                        <div className="nav-contact-us_child">
                            <div>
                                <img id="contact-phone" src={PHONE_ICON} alt=""/>
                            </div>
                            <span>(876) 927-7071</span>
                        </div>
                        <div className="nav-contact-us_child">
                            <div>
                                <img src={EMAIL_ICON} alt=""/>
                            </div>
                            <span>sbajinfo@sba-jm.org</span>
                        </div>
                        <div className="nav-contact-us_child">
                            <div>
                                <img src={LOCATION_ICON} alt=""/>
                            </div>
                            <span>2 Trafalgar Road, Kingston 5, Jamaica</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AccountingFinanceChildren = () => {
    return (
        <div className="links_link_children">
            <div className="links_link_children_left">
                <h1>Accounting & Finance</h1>
                <p>
                    This section could possibly be a slide, with information about various
                    features.
                </p>
            </div>
            <div className="links_link_children_right">
                <div className={'links_link_children_routes'}>
                    <HashLink smooth to="/finance#business-loans">Business Loans & Grants</HashLink>
                    <HashLink smooth to="/finance#business-banks">Local Bank Loan Services </HashLink>
                    <HashLink smooth to="/finance#business_upcoming_events">Upcoming Events</HashLink>
                </div>
                <div className={'links_link_children_routes'}>
                    <HashLink smooth to="/finance#financial_help">Tax Administration</HashLink>
                    <HashLink smooth to="/finance#financial_help">Hr & Payroll</HashLink>
                    <HashLink smooth to="/finance#financial_help">Business Accounting</HashLink>
                </div>
            </div>
        </div>
    );
};





